import React from "react";
import "./Experience.css";
import Fade from "react-reveal/Fade";
const Experience = () => {
  return (
    <div className="experience" id="experience">
      <h2 className="font-heading pt-5 mt-5 text-center">
        <span className="about-title ">Experiences</span>
      </h2>
      <div className="container my-5 details-div">
        <div className="row py-3">
          <h4 className="font exp-title1">Frontend Developer Intern</h4>
          <h6 className="font exp-title2">
            {" "}
            <a
              href="https://pupten.com/"
              target="_blank"
              className="companyName"
            >
              Pupten
            </a>{" "}
            (June 2021-August 2021)
          </h6>
        </div>
        <div className="row font ">
          <Fade left>
            <ul className="mx-3 deet">
              <li>Developed the landing page of the company's website.</li>
              <li>
                Participated in team meetings with people from different
                cultures for efficient planning purposes.
              </li>
              <li>
                Developed user-centric website in collaboration with UI
                designers.
              </li>
            </ul>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default Experience;
